// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1OTqQ","name":"ConsentHeader_name__1012t","birthday":"ConsentHeader_birthday__2xvPv","skeleton":"ConsentHeader_skeleton__36g-O"};